import { __extends } from "tslib";
import Application from './Application';
import { Route } from 'react-router';
import Managers from '../../Architecture/Managers/Constants/Managers';
var ContentViewRoute = /** @class */ (function (_super) {
    __extends(ContentViewRoute, _super);
    function ContentViewRoute() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isVisible = false;
        return _this;
    }
    ContentViewRoute.prototype.render = function () {
        if (Application.current != undefined) {
            if (Application.current.resolve(Managers.NAVIGATION_MANAGER).route != this.props.location.pathname) {
                Application.current.resolve(Managers.NAVIGATION_MANAGER).route = this.props.location.pathname;
            }
        }
        return (_super.prototype.render.call(this));
    };
    return ContentViewRoute;
}(Route));
export default ContentViewRoute;
